import React, { useState } from 'react';
import {
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBIcon,
}
    from 'mdb-react-ui-kit';

const Modal = ({ open, toggleOpen, content, hideSec, title, onConfirm, onReject, secondaryText, primaryText, modalTopValue, closeAnchorId }: any) => {
    return (
        <>
            <MDBModal className='modal-dialog-centered' open={open} onClose={() => { toggleOpen() }} tabIndex='-1' style={{ display: 'flex' }}>
                <MDBModalDialog style={{ minWidth: Math.min(document.documentElement.clientWidth * 0.32, 480), maxWidth: 520 }}>
                    <MDBModalContent style={{ borderRadius: 14, overflow: 'hidden' }}>
                        <MDBModalHeader style={{ padding: '18px 24px', alignItems: 'center' }}>
                            <MDBModalTitle style={{ fontSize: '1.1rem', fontWeight: 600, margin: 0 }}>{title}</MDBModalTitle>
                            <MDBBtn id={closeAnchorId} floating onClick={() => { toggleOpen() }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, height: 32, width: 32 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 30 30">
                                    <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z" stroke="#FFF" fill="#FFF"></path>
                                </svg>
                            </MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody style={{ padding: '24px' }}>
                            {content}
                        </MDBModalBody>

                        <MDBModalFooter style={{ padding: '16px 24px', gap: 12 }}>
                            {!hideSec ?
                                <MDBBtn color='secondary'
                                    onClick={() => {
                                        if (!onReject) {
                                            toggleOpen()
                                        }
                                        else {
                                            onReject()
                                        }
                                    }}
                                    style={{ minWidth: 96 }}
                                >
                                    {secondaryText ? secondaryText : 'No'}
                                </MDBBtn> : null}
                            <MDBBtn
                                style={{ minWidth: 96 }}
                                onClick={() => {
                                    onConfirm();
                                }}
                            >{primaryText ? primaryText : 'Yes'}</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>

    )
}

export default Modal;
